import React, { forwardRef } from 'react';
import MUIButton, {
  ButtonProps as MUIButtonProps,
} from '@material-ui/core/Button';

export interface ButtonProps extends MUIButtonProps {}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { size = 'small', disableElevation = true, ...rest } = props;

  return (
    <MUIButton
      {...rest}
      disableElevation={disableElevation}
      disableRipple
      ref={ref}
      size={size}
    />
  );
});

Button.displayName = 'Button';

export default Button;
